import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from 'yup';

import { Hooks } from 'providers';
import { Organization } from 'providers/Organization';
import { useOuterClick } from 'providers/OutsideClick';

import {
  HIT_LIST_ORGANIZATION,
  HIT_UPDATE_STRUCTURE,
} from 'redux/actions/organization';

import Modal from 'components/_parts/atoms/modal/index';

function ModalForm(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    pid__, tagAdd, modalUpdate, setModalUpdate, setPid__, dataUpdate,
  } = useContext(Organization);
  const { setModal: setModal__, modal: modal__ } = useContext(Hooks);
  const { job_, loading } = useSelector((state) => ({
    job_: state.organization.list_job.map((val) => ({
      value: val.job_level_id,
      label: val.name,
    })),
    loading: state?.loading?.trigger,
  }));

  const innerRef = useOuterClick((e) => {
    if (e.srcElement.id === 'updateNodesStructure') {
      setModalUpdate(false);
    }
  });

  const formik = useFormik({
    initialValues: {
      job_level_id: '',
      tag: '',
      report: '',
      name: '',
      job_grade: '',
      job_level_id_show_only: '',
      tag_show_only: '',
      organization_id: '',
    },
    validationSchema: Yup.object().shape({
      job_level_id: Yup.string()
        .typeError('Must be string')
        .required('Job Level ID cannot empty'),
      tag: Yup.string()
        .typeError('Must be string')
        .required('Field tag cannot empty'),
      //   report: Yup.string()
      //     .typeError("Must be string")
      //     .required("Field report to cannot empty"),
      name: Yup.string()
        .typeError('Must be string')
        .required('Field name cannot empty'),
      job_grade: Yup.string()
        .typeError('Must be string')
        .required('Field job grade cannot empty'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const NewData = {
        // organization_id: newNode["Organization ID"],
        job_grade: formik.values.job_grade,
        job_level_id: formik.values.job_level_id,
        organization_id: formik.values.organization_id,
        purpose: formik.values.purpose,
        name: formik.values.name,
        tag: formik.values.tag,
      };
      if (formik.values.report_to !== null) {
        NewData.report_to = formik.values.report_to;
      }
      await dispatch({
        type: HIT_UPDATE_STRUCTURE,
        payload: {
          data: NewData,
          board_id: localStorage.getItem('board_id'),
        },
      });
      await setTimeout(() => {
        dispatch({
          type: HIT_LIST_ORGANIZATION,
          payload: {
            board_id: localStorage.getItem('board_id'),
          },
        });
      }, 0);
      setModalUpdate(false);
      setModal__(false);
      formik.resetForm();
      formik.setValues({});
      setPid__('random');
    },
  });

  useEffect(() => {
    formik.setValues({
      job_level_id_show_only: {
        values: dataUpdate?.[0]?.job_level_id,
        label: dataUpdate?.[0]?.job_level_name,
      },
      tag_show_only: {
        values: dataUpdate?.[0]?.tag?.toString(),
        label: dataUpdate?.[0]?.tag === 1 ? 'Yes' : 'No',
      },
      tag: dataUpdate?.[0]?.tag?.toString(),
      job_level_id: dataUpdate?.[0]?.job_level_id,
      report: dataUpdate?.[0]?.report_to,
      name: dataUpdate?.[0]?.name,
      job_grade: dataUpdate?.[0]?.job_grade,
      purpose: dataUpdate?.[0]?.purpose,
      organization_id: dataUpdate?.[0]?.organization_id,
    });
  }, [dataUpdate]);

  useEffect(() => {
    // dispatch({
    //   type: HIT_LIST_JOB,
    //   payload: {
    //     //board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
    //     board_id: localStorage.getItem("board_id"),
    //   },
    // });
    // dispatch({
    //   type: HIT_LIST_ORGANIZATION,
    //   payload: {
    //     //board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
    //     board_id: localStorage.getItem("board_id"),
    //   },
    // });
  }, []);

  return (
    <div
      className={`modal fade rModal ${modalUpdate && 'show'}`}
      style={{
        width: 'fit-content',
        display: modalUpdate ? 'block !important' : 'none !important',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div
        id="updateNodesStructure"
        className="org-chart org-chart w-100 h-100 d-flex my-auto mx-auto"
      >
        <div className="org-chart_wrap my-auto mx-auto">
          <form action="" onSubmit={() => formik.handleSubmit()}>
            <h3>{props.title}</h3>
            <label>Job Level</label>
            {/* <input
            className="form-control form-control-md mb-2 "
            type="text"
            name="job_level_id"
            placeholder="Enter your name"
          /> */}
            <Select
              // styles={customStyles}
              options={job_}
              name="job_level_id"
              id="job_level_id"
              onChange={(e) => {
                formik.setValues({
                  ...formik.values,
                  job_level_id: e.value,
                  job_level_id_show_only: {
                    values: e.value,
                    label: e.label,
                  },
                });
              }}
              value={formik.values.job_level_id_show_only}
              // defaultInputValue={{
              //   value: 1,
              //   label: 2,
              // }}
            />
            {formik.touched.job_level_id && formik.errors.job_level_id ? (
              <>
                <span className="error">{formik.errors.job_level_id}</span>
                <br />
              </>
            ) : null}
            <label>Job Title</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="name"
              value={formik.values.name}
              defaultValue={dataUpdate?.[0]?.Nama}
              placeholder="Enter Job Title"
              onChange={formik.handleChange}
            />
            {formik.touched.name && formik.errors.name ? (
              <>
                <span className="error">{formik.errors.name}</span>
                <br />
              </>
            ) : null}
            <label>Tag</label>
            <Select
              options={tagAdd}
              id="tag"
              name="tag"
              onChange={(e) => {
                formik.setValues({
                  ...formik.values,
                  tag: e.value,
                  tag_show_only: {
                    values: e.value,
                    label: e.label,
                  },
                });
              }}
              value={formik.values.tag_show_only}
            />
            {/* <input
            className="form-control form-control-md mb-2 "
            type="text"
            name="tag"
            id="tag"
            value={formik.values.tag}
            onChange={formik.handleChange}
            placeholder="Enter your name"
          /> */}
            {formik.touched.tag && formik.errors.tag ? (
              <>
                <span className="error">{formik.errors.tag}</span>
                <br />
              </>
            ) : null}
            <label>Job Grade</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="job_grade"
              onChange={formik.handleChange}
              value={formik.values.job_grade}
              placeholder="Enter Job Grade"
            />
            {formik.touched.job_grade && formik.errors.job_grade ? (
              <>
                <span className="error">{formik.errors.job_grade}</span>
                <br />
              </>
            ) : null}
            <label>Purpose</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="purpose"
              onChange={formik.handleChange}
              value={formik.values.purpose}
              placeholder="Enter Purpose"
            />
            <label>Report to</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="report"
              value={formik.values.report || formik.values.organization_id}
              disabled
              id="report"
              placeholder="Enter your name"
              onChange={formik.handleChange}
            />
            {formik.touched.report_to && formik.errors.report_to ? (
              <>
                <span className="error">{formik.errors.report_to}</span>
                <br />
              </>
            ) : null}

            <div className="btn-submit d-flex justify-content-center align-items-center float-right mt-4">
              <button
                className="add"
                type="button"
                onClick={(e) => {
                  formik.handleSubmit(e);
                }}
              >
                {t('board.submit')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalForm;
